import { AgencySortFieldEnum } from "~/__generated__/graphql"
import { useAgencySort } from "./AgencySortContext"
import { SortableColumnHeader } from "~/ui/SortableColumnHeader"

export const SortableColumn = ({
  field,
  children,
}: {
  field: AgencySortFieldEnum
  children: React.ReactNode
}) => {
  const { sortField, sortDir, onSort } = useAgencySort()

  return (
    <SortableColumnHeader
      onClick={() => onSort(field)}
      sortDir={sortDir}
      isActiveSort={field === sortField}
    >
      {children}
    </SortableColumnHeader>
  )
}
